import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import {
  captureWorkOSOAuthFromSearch,
  getWorkOSOAuthSessionStorage,
  isWorkOSOAuthLoginPath,
} from './navigation/workosOAuth';

// Strip WorkOS's one-shot handoff before React, the router, analytics, or any
// authenticated application surface mounts. The identifier remains tab-local.
if (isWorkOSOAuthLoginPath(window.location.pathname)) {
  const capture = captureWorkOSOAuthFromSearch(
    window.location.search,
    getWorkOSOAuthSessionStorage(),
  );
  if (capture.hadExternalAuthId) {
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${capture.sanitizedSearch}${window.location.hash}`,
    );
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
